import { ADMIN, EMPLOYEE, USER } from "../../../../enums/Roles";

/**
 * The pet owner the appointment is for. Staff-booked appointments store the
 * staff member as `appointment.user`, so the pet's own owner is used then.
 */
export function getAppointmentOwner(appointment) {
  return [appointment?.user, appointment?.pet?.user].find(
    (user) => String(user?.role) === USER,
  );
}

/** Whether the clinic booked the appointment for itself, with no pet owner behind it. */
export function isInternalAppointment(appointment) {
  return (
    [ADMIN, EMPLOYEE].includes(String(appointment?.user?.role)) &&
    !getAppointmentOwner(appointment)
  );
}
